export const GET_INGREDIENTS__REQUEST = 'GET_INGREDIENTS__REQUEST' as const;
export const GET_INGREDIENTS__SUCCESS = 'GET_INGREDIENTS__SUCCESS' as const;
export const GET_INGREDIENTS__FAILURE = 'GET_INGREDIENTS__FAILURE' as const;
export const ADD_INGREDIENT = 'ADD_INGREDIENT' as const;
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT' as const;
export const CHANGE_BUN = 'CHANGE_BUN' as const;
export const REORDER_INGREDIENTS = 'REORDER_INGREDIENTS' as const;
export const POST_ORDER__REQUEST = 'POST_ORDER__REQUEST' as const;
export const POST_ORDER__SUCCESS = 'POST_ORDER__SUCCESS' as const;
export const POST_ORDER__FAILURE = 'POST_ORDER__FAILURE' as const;
export const CURRENT_ITEM_OPEN = 'CURRENT_ITEM_OPEN' as const;
export const CURRENT_ITEM_CLOSE = 'CURRENT_ITEM_CLOSE' as const;
export const SET_TOTAL_PRICE = 'INCREASE_TOTAL_PRICE' as const;
export const RESET_CONSTRUCTOR = 'RESET_CONSTRUCTOR' as const;
